import { useRouteError } from 'react-router-dom'
import { Layout } from './layout'
import { Button } from './button'
import { isChunkLoadError, reloadOnce } from '@/utils/chunk-reload'

export default function ChunkLoadErrorBoundary() {
  const error = useRouteError()

  if (isChunkLoadError(error) && reloadOnce()) return null

  const errorMessage = error instanceof Error ? error.message : String(error)

  // Fallback UI for chunk errors that persist after reload,
  // or for any other unexpected errors
  return (
    <Layout title="Refresh Required">
      <div className="space-y-6">
        <p className="font-medium">
          A new version of Rundown Studio is available.
        </p>

        <div className="text-gray-500 space-y-2">
          <p>
            Please refresh the page to apply the latest update and continue
            where you left off.
          </p>
          <p>
            If this keeps happening, please contact us at{' '}
            <a
              href="mailto:hello@rundownstudio.app"
              className="underline hover:text-gray-400"
            >
              hello@rundownstudio.app
            </a>
          </p>
        </div>

        <Button
          text="Refresh Now"
          onClick={() => window.location.reload()}
        />

        <hr className="border-gray-800" />

        {/* We include the actual error message here for when people send us screenshots */}
        <div className="text-sm text-gray-700 text-center">
          &quot;{errorMessage}&quot;
        </div>
      </div>
    </Layout>
  )
}
